import React from 'react';

import { EmptyState } from '@lumapps/lumx-states/components/EmptyState';
import { useTranslate } from '@lumapps/translations';

import { EMPTY_STATES } from '../../constants';

export interface AskAiErrorStateProps {
    /** The current error status */
    status?: number;
}

/**
 * Error state of the ask ai banner
 * Will display an specific error for maximum usage
 */
export const AskAiErrorState: React.FC<AskAiErrorStateProps> = ({ status }) => {
    const { translateKey } = useTranslate();

    return (
        <EmptyState
            title={translateKey(EMPTY_STATES.error.subtitle)}
            message={translateKey(
                status === 429
                    ? EMPTY_STATES.error.description.reachedMaximumUsage
                    : EMPTY_STATES.error.description.default,
            )}
            iconProps={{ icon: EMPTY_STATES.error.icon }}
        />
    );
};
